const state = {
  demoMessage: false,
};

const mutations = {
  CHANGE_DEMO_ACTIVE(state, demoMessage) {
    state.demoMessage = demoMessage;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  demoMessage: (state) => {
    return state.demoMessage;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
